<!-- ================= HEADER ================= -->
<div class="container">
  <div class="row mb-1">
    <div class="col-md-12 d-flex justify-content-between align-items-center">
      <h5>Online Drivers</h5>

      <button
        class="btn btn-success btn-shadow d-inline-flex align-items-center"
      >
        <i class="fa fa-arrow-circle-left me-2"></i> Back
      </button>
    </div>
  </div>

  <!-- 🔍 SEARCH INPUT (Google Autocomplete attaches here) -->
  <div class="row mb-2">
    <div class="col-md-6">
      <input
        type="text"
        id="searchInput"
        class="form-control location-input"
        placeholder="Search location"
      />
    </div>
  </div>
</div>

<!-- ================= MAP SECTION ================= -->
<div class="map-wrapper">
  <!-- Google map -->
  <div id="map"></div>

  <!-- 📍 CENTER PIN (fixed, NOT a Google marker) -->
  <div class="center-pin">
    <div class="pulse"></div>
    <img src="assets/images/greenIcon.png" alt="Center Pin" />
  </div>
  <!-- ================= DRIVER DETAILS PANEL ================= -->
  <!-- ================= DRIVER INFO CARD ================= -->
  <div class="driver-card" *ngIf="showDriverPanel">
    <div class="card-header">
      <span>Driver</span>
      <i class="fa fa-times close" (click)="closeDriverPanel()"></i>
    </div>

    <div class="card-body" *ngIf="selectedDriver">
      <p>
        <strong>{{ driverData.firstName }} {{ driverData.lastName }}</strong>
      </p>
      <p>{{ driverData.phoneNumber }}</p>
      <p class="vehicle">{{ driverData.vehicleType }}</p>

      <span class="badge bg-success">Online</span>
    </div>
  </div>
</div>
